import { useFlagshipFlag } from '../../helpers/useFlagshipFlag';
import { LANDING_PAGE_CTA_TEXT } from '../experiments.constants';

export const useLandingPageCTAText = (visitorExposed: boolean) =>
  useFlagshipFlag({
    key: LANDING_PAGE_CTA_TEXT,
    defaultValue: 'Get My Policy',
    visitorExposed: visitorExposed,
  });
